/* eslint-disable import/no-cycle */
import api from './api.service';

function getRoles() {
  return api.get('/roles-availables');
}

function index(params) {
  return api.get('/permissions', params);
}

export const permissionsService = {
  getRoles,
  index,
};
